import { EditorView } from 'prosemirror-view';
import { EditorState } from 'prosemirror-state';
import { exampleSetup } from './setup/index.js';
import keymapper from './keymapper';
import buildMenu from './menuBuilder';
import linkEditor from './link_editor';
import pasteHandler from './paste_handler';
import * as Sentry from '@sentry/browser';

const ProseMirror = function(container, schema, keymap = {}, plugins = [], doc) {
   const linkEditorPlugin = linkEditor(container);
   const setupOptions = {
      schema,
      menuContent: buildMenu(schema),
   };

   const stateOptions = {
      schema,
      plugins: [
         keymapper(schema, keymap),
         linkEditorPlugin,
         pasteHandler,
         ...plugins,
         ...exampleSetup(setupOptions),
      ],
   };

   if (doc) {
      stateOptions.doc = getNodeFromJson(schema, doc);
   }

   const editor = new EditorView(container, {
      state: EditorState.create(stateOptions),
      linkEditorKey: linkEditorPlugin.key,
   });

   editor.dom.prosemirror = editor;
   return editor;
};

function getNodeFromJson(schema, doc) {
   try {
      const document = schema.nodeFromJSON(doc);
      document.check();
      return document;
   } catch (err) {
      // Document is invalid. Send user to plaintext editor and log stat.
      trackEvent('Prosemirror', 'Crash');

      // Log the error so we can see why the page is redirecting
      console.error(err);

      // Capture the error in Sentry. This gives us additional
      // awareness of what's breaking (since it's likely our fault).
      Sentry.captureException(err);

      // Redirect page once error-monitoring code has had a chance to
      // deal with the thrown exception below.
      const url = new URL(document.location.href);
      url.searchParams.append('plaintext', 1);
      window.location = url.href;
   }
}

export default ProseMirror;
